import React from "react";

import { useState } from "react";
import { Box, ScrollArea, Table, Text, createStyles } from "@mantine/core";

import { useSelector } from "react-redux";
import PatientTableRow from "../PatientTableRow";
import RecordNotFound from "../RecordNotFound";
import TableLoader from "../TableLoader";

const useStyles = createStyles((theme) => ({
  tableWrap: {
    marginTop: 16,
    minHeight: 300,
    background: "#fff",
    border: "1px solid #E5E5E5",
    borderRadius: 12,
    boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
    overflow: "hidden",
    width: "100%",
    overflowX: "auto",
  },
  table: {
    fontFamily: "Inter",
    minWidth: 1020,
  },
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    "& th": {
      backgroundColor: "#F2F2F2",
      color: "#000 !important",
      fontSize: "12.5px !important",
      fontWeight: "600 !important",
      borderBottom: "1px solid #E5E5E5 !important",
      fontFamily: "Inter",
      padding: "14px 16px !important",
    },
    "& th:first-of-type": {
      borderTopLeftRadius: "12px !important",
    },
    "& th:last-of-type": {
      borderTopRightRadius: "12px !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
    },
  },

  scrolled: {
    boxShadow: theme.shadows.sm,
    borderRadius: "15px",
  },
  thClient: { minWidth: "200px" },
  thFacility: { minWidth: "200px" },
  thDate: { minWidth: "140px" },
  thDob: { minWidth: "80px" },
  thGuardian: { minWidth: "140px" },
  thPhone: { minWidth: "140px" },
  thActive: { minWidth: "140px" },
  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },
  notFoundTextContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
    height: "75vh",
    gap: "8rem",
  },
}));

const PatientTable = ({ data, onEdit, selectedTab, searchQuery = "" }) => {
  const { classes, cx } = useStyles();
  const { patients, loading } = useSelector((state) => state.patient);
  const [scrolled, setScrolled] = useState(false);

  const filteredPatients = searchQuery.trim()
    ? patients?.patients?.filter((p) =>
        p?.name?.toLowerCase().includes(searchQuery.trim().toLowerCase())
      )
    : patients?.patients;

  const rows = filteredPatients?.map((row, i) => (
    <PatientTableRow
      row={row}
      key={i}
      onEdit={onEdit}
      selectedTab={selectedTab}
    />
  ));

  return (
    <ScrollArea
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
      className={classes.tableWrap}
    >
      <Table
        highlightOnHover
        enableStickyHeader
        className={classes.table}
        fontSize={"sm"}
        verticalSpacing={"md"}
      >
        <thead className={cx(classes.header, { [classes.scrolled]: scrolled })}>
          <tr>
            <th className={classes.thClient}>Client</th>
            <th className={classes.thFacility}>Facility</th>
            <th className={classes.thDate}>Intake Date</th>
            <th className={classes.thDob}>DOB</th>
            <th className={classes.thGuardian}>Guardian Name</th>
            <th className={classes.thPhone}>Guardian Number</th>
            {selectedTab !== true && (
              <>
                <th className={classes.thDate}>Discharge Reason</th>
                <th className={classes.thDate}>Discharge Date</th>
              </>
            )}
            <th className={classes.thActive}>Active</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan={1000}>
                <TableLoader />
              </td>
            </tr>
          ) : rows?.length ? (
            <>{rows}</>
          ) : (
            <tr>
              <td colSpan={1000}>
                <Box className={classes.notFoundTextContainer}>
                  <RecordNotFound />
                  <Text className={classes.notFoundText}>
                    You don&apos;t have any record, click on “Add Client”
                  </Text>
                </Box>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </ScrollArea>
  );
};

export default PatientTable;
